import { vnTemplate } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import {amCharts_v4_date_basic_template} from "./amCharts_v4_date_basic_template";
import { filterSingle_multiLevel_selector_template } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingle_multiLevel_selector_template';
import {filterAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterAutoComplete_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterMultipleAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterMultipleAutoComplete_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import { vnApp_sentinelbi } from '../vnApp_sentinelbi';


declare var ko: any;
declare var page: any;


export class googleInsights_template extends vnTemplate {

    protected presetFilter: presetFilter_template;
    protected brandFilter: filterSingle_multiLevel_selector_template;
    protected indicatorsChart: amCharts_v4_date_basic_template;
    protected dateRangeFilter: filterDate_template;
    protected searchField: filterSimple_template;
    protected pagination: pagination_template;
    protected resultsInfo: resultsInfo_template;
    protected exportDataCsv: exportDataCsv;
    protected annotationTooltip: infoButton_template;

    /**
     * @inheritDoc
     */
    protected getTemplateHtml(): string{

        return `



        <div class="page-content">

            <div id="report-results">

                <div class="page-header">
                    <h2 class="title-page">Google Discover</h2>
                </div>

                <div class="w-justify block-filters filters-responsive">


                    <nav class="sidebar-default sidebar-default-right" data-bind="css:{'is-open': isFiltersOpen()}">
                        <div class="sidebar-default-header">
                            <span class="label-default sidebar-default-header icon i-filters">Filters</span>
                            <button type="button" class="btn-close-default icon i-close" data-bind="event: { click: toggleOpenFilters }"><span></span></button>
                        </div>

                        <div class="sidebar-default-body">

                            <div>

                                <!-- ko foreach: dynamicFiltersGrouped -->

                                    <span class="form-label" data-bind="text: categoryName"></span>

                                    <div class="dynamic-filters w-add-filters-list">
                                    <!-- ko foreach: Object.values(names) -->

                                        <div class="filter-group">

                                            <div class="checkbox-group">
                                                <label class="icon i-dropdown-simple">
                                                    <input class="expected" type="checkbox" />
                                                </label>
                                            </div>

                                            <!-- ko foreach: filters -->

                                                <!-- ko if: type === 'multiSelect' -->
                                                    <div data-bind="template: {name: 'multiSelector-template', data: filter.getTemplateViewModel()}" class="has-multi"></div>
                                                <!-- /ko -->

                                                <!-- ko if: type === 'autoCompleteMultiSelect' -->
                                                    <div data-bind="template: {name: 'filterMultipleAutoComplete-template', data: filter.getTemplateViewModel()}"></div>
                                                <!-- /ko -->

                                                <!-- ko if: type === 'searchField' -->
                                                    <div data-bind="template: {name: 'filterSimple-template', data: filter.getTemplateViewModel()}"></div>
                                                <!-- /ko -->

                                            <!-- /ko -->
                                        </div> <!-- End filter-group -->
                                    <!-- /ko -->
                                    </div>
                                <!-- /ko -->

                            </div>
                        </div>
                    </nav>

                    <div class="w-right flex-all block-default">
                        <div class="w-justify full-width">
                            <div class="w-left">
                               <div class="w-brand-filter">
                                     ${this.brandFilter.getHtmlBuild()}
                                </div>
                                <div >
                                    ${this.dateRangeFilter.getHtmlBuild()}
                                </div>

                                <button class="icon i-filters no-after filterToggle-btn" data-bind="event: {click: toggleOpenFilters}">Filters</button>

                            </div>

                            <div class="w-right">
                                <div class="w-filter-preset hide-mobile" data-bind="visible: false, event: { mouseover: onMouseOverPreset, mouseout: onMouseOutPreset}">
                                    ` + this.presetFilter.getHtmlBuild() + `
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="w-justify">
                    <div class="w-left">
                        <div class="w-filters-selected">
                            <div id="filters-selected" class="filters-selected">
                                <div id="selected-geos"></div>
                                <div id="selected-devices"></div>
                                <div id="selected-os"></div>
                                <div id="selected-browsers"></div>
                                <div id="selected-login-status"></div>
                                <div id="selected-referrers"></div>
                                <div id="selected-plans"></div>
                                <!-- ko foreach: dynamicFilters -->
                                    <div data-bind="attr: { id: 'selected-' + name }"></div>
                                <!-- /ko -->
                            </div>
                        </div>
                    </div>
                </div>

                <div>

                    <section class="w-graph block-default rogue no-padding">
                        <div class="w-justify" style="width: 100%;margin-top: 1rem">
                            <div style="margin-right: 1rem" class="w-right" data-bind= "visible: timelineAnnotationsData().length">
                                <span class="label-annotation"></span>
                                <div class="w-tooltips-adv auto-height short pos-top-left">
                                    ${this.annotationTooltip.getHtmlBuild()}
                                </div>
                            </div>
                        </div>
                        <div class="graph" id="permalinksIndicatorsBySearchByDate-results">
                            ${this.indicatorsChart.getHtmlBuild()}
                        </div>
                    </section>

                    <div id="permalinksBySearchByDate-results" class="wrapper-list-results">

                        <div class="w-justify list-results-header">

                            <div class="w-left">
                                <h2 class="section-title icon i-keywords">Search Page Paths</h2>
                                 ` + this.resultsInfo.getHtmlBuild() + `
                            </div>

                            <div class="w-center">
                                `+ this.searchField.getHtmlBuild() + `
                            </div>

                            <div class="w-right">
                                ` + this.pagination.getHtmlBuild() + `
                                <button class="button-default icon i-export" type="button" data-bind="event: { click: exportData}">Export</button>
                            </div>

                        </div>

                        <div class="gradient-overflow">
                            <div class="w-list-results">
                                <table class="list-results list-sections">

                                    <thead>
                                        <tr>
                                            <th>
                                                <span>Property</span>
                                            </th>
                                            <th>
                                                <span>Page Path</span>
                                            </th>
                                            <th>
                                                <span>Clicks</span>
                                            </th>

                                            <th>
                                                <span>CTR</span>
                                            </th>

                                            <th>
                                                <span>Impressions</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- ko if : permalinksTotalRow().length > 0 -->
                                            <tr class="total-row">
                                                <td>
                                                    <span data-bind="text: 'Total'"></span>
                                                </td>

                                                <!-- ko foreach: permalinksTotalRow -->
                                                    <td></td>
                                                    <td>
                                                        <span class="row-percentage" data-bind="text: Number(clickCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) "></span>
                                                    </td>
                                                    <td>
                                                        <span class="row-percentage" data-bind="text: Number(ctr).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                                    </td>
                                                    <td>
                                                        <span class="row-percentage" data-bind="text: Number(impressionCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) "></span>
                                                    </td>
                                                <!-- /ko -->
                                            </tr>
                                        <!-- /ko -->
                                        <!-- ko foreach: permalinksData -->
                                            <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data)}, style: { 'background-color': $parent.selectedRows().indexOf($index()) !== -1 ? '#dbdbed' : '' }">
                                                <td class=""><span data-bind="text: brand"></span></td>

                                                <td>
                                                    <span data-bind="text: subdomain  && subdomain != 'www'? (subdomain + ' ... ' + permalink) : permalink"></span>
                                                    <a class="icon i-ext-link" data-bind="event: { click: $parent.stopPropagation }, attr: {href: permalinkUrl}" target="_blank"></a>
                                                </td>

                                                <td class=""><span data-bind="text: Number(clickCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                                <td class=""><span data-bind="text: Number(ctr).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                                <td class=""><span data-bind="text: Number(impressionCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                            </tr>
                                        <!-- /ko -->
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <footer class="default-footer">
                <span class="logo-short"></span>
                <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
                <span>|</span>
                <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
            </footer>
        `;
    }

    /**
     * @inheritDoc
     */
    protected initPartial(): void{

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('googleInsights');

        this.brandFilter = new filterSingle_multiLevel_selector_template('brandFilter', this.getTemplateViewModel(), this.caller);
        this.brandFilter.setLabel('Property');
        this.brandFilter.setAllOptionsText('Network');
        this.brandFilter.setHasLogo(true);
        this.brandFilter.setDefaultLogo(vnApp_sentinelbi.BRAND_DEFAULT_ICON_PATH);

        this.searchField = new filterSimple_template("searchField",this.getTemplateViewModel(),this.caller);

        this.pagination   = new pagination_template('pagination', this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.resultsInfo  = new resultsInfo_template('resultsInfo', this.getTemplateViewModel(), this.caller);

        this.exportDataCsv = new exportDataCsv();


        let date = new Date();
        date.setHours(0,0,0,0);
        let firstOfMonth = new Date(date.getFullYear(),date.getMonth(), 1);

        // if it is the first day of the month, we display data from the last month
        if(date.getTime() === firstOfMonth.getTime()){
            firstOfMonth = new Date(date.getFullYear(),date.getMonth() - 1, 1);
            date.setDate(date.getDate());
        }else{
            date.setDate(date.getDate());
        }


        this.dateRangeFilter = new filterDate_template("dateRangeFilter", this.getTemplateViewModel(), this.caller);
        this.dateRangeFilter.setStartPickerId('dateRangeStartDatePicker');
        this.dateRangeFilter.setEndPickerId('dateRangeEndDatePicker');
        this.dateRangeFilter.setDateRange(firstOfMonth, date);


        this.indicatorsChart = new amCharts_v4_date_basic_template('indicatorsChart', this.getTemplateViewModel(), this.caller);


        window.addEventListener('click', event => {

            const sidebarFilters = document.querySelector('.sidebar-filters-js-only');
            const addFiltersDropdown = document.querySelector('.sidebar-default-right');
            const addFiltersButton = document.querySelector('.filterToggle-btn');

            if(!sidebarFilters?.contains(event.target as Element)){
                this.getTemplateViewModel().sidebarToggle(false);
            }

            if(!addFiltersDropdown?.contains(event.target as Element) && !addFiltersButton?.contains(event.target as Element) && !(event.target as Element).closest('.form-auto-item') && !(event.target as Element).closest('.btn-f-s')){
                this.getTemplateViewModel().isFiltersOpen(false);
            }
        })

        this.annotationTooltip = new infoButton_template('annotationTooltip', this.getTemplateViewModel(), this.caller)
        this.annotationTooltip.setContent('');
    }

    /**
     * @inheritDoc
     */
    protected getTemplateName(): string{

        return 'googleInsights_template';
    }

    /**
     * @inheritDoc
     */
    public buildViewModel(): Object{

        let self = this;

        return {
            dynamicFiltersData: ko.observableArray([]),
            dynamicFilters: ko.observableArray([]),
            dynamicFiltersGroupedByName: ko.observableArray([]),
            dynamicFiltersGrouped: ko.observableArray([]),
            permalinksData: ko.observableArray([]),
            permalinksTotalRow: ko.observableArray([]),
            graphAxes: ko.observableArray([]),
            graphLines: ko.observableArray([]),
            indicatorsDateRange: ko.observableArray([]),
            indicatorsDateRangeEmpty: ko.observable(false),
            timelineAnnotationsData: ko.observableArray([]),
            isPresetVisible: ko.observable(false),
            permalinksExportData: ko.observableArray([]),
            dateStartSelected: ko.observable(),
            dateEndSelected: ko.observable(),
            selectedRows: ko.observable([]),
            exportData: function(){ self.getCsvData(); },
            sidebarToggle: ko.observable(false),
            isFiltersOpen: ko.observable(false),
            onMouseOverPreset : function () {
                self.onMouseOverPreset();
            },
            onMouseOutPreset : function () {
                self.onMouseOutPreset();
            },
            toggleOpenFilters: function(data){
                self.toggleOpenFilters();
            },
            onClickRowClick: function(index, data){

                self.onClickRowClick(index);
            },
            stopPropagation: function(data, event){

                self.stopPropagation(event);
                return true;
            },
            formatMinuteSeconds: function(value){
                return self.formatMinuteSeconds(value);
            },
            onSidebarToggle: function(){
                self.onSidebarToggle();
            }
        }


    }

    protected onMouseOverPreset(){

        this.getTemplateViewModel().isPresetVisible(true);
    }

    protected onMouseOutPreset(){

        this.getTemplateViewModel().isPresetVisible(false);
    }

    public toggleOpenFilters(){

        this.getTemplateViewModel().isFiltersOpen(!this.getTemplateViewModel().isFiltersOpen());
    }

    private onSidebarToggle(){

        this.getTemplateViewModel().sidebarToggle(!this.getTemplateViewModel().sidebarToggle());
    }

    public setDynamicFilters(dynamicFiltersData: Array<any>){

        let i = 0;
        let dynamicFilters = [];

        for (let category in dynamicFiltersData) {

            if (dynamicFiltersData.hasOwnProperty(category)) {

                let filtersData = dynamicFiltersData[category];

                filtersData.forEach((filterData) => {

                    let filter, filterId;

                    // multi select
                    if(filterData.type === 'multiSelect'){

                        filterId = filterData.id;
                        filter = new multipleSelector_template(filterId, this.getTemplateViewModel(), this.caller);
                        filter.setLabel(filterData.name);
                        filter.setTagContainerId('selected-' + filterData.name);
                        filter.setTagContainerCaption('Selected ' + filterData.name + ':');
                        filter.setItems(filterData.values);
                        filter.setShowCount(true);
                        filter.setShowClear(true);


                        if(filterData.hasSearchFilter){

                            filter.setContainSearchEnabled(true);
                        }

                        dynamicFilters.push({
                            filter: filter,
                            filterId: filterId,
                            name: filterData.name,
                            type: filterData.type,
                            category: filterData.category,
                            categoryName: filterData.categoryName
                        });
                    }
                    // multi select autocomplete
                    else if(filterData.type === 'autoCompleteMultiSelect'){

                        filterId = filterData.id;
                        filter = new filterMultipleAutoComplete_template(filterId, this.getTemplateViewModel(), this.caller);
                        filter.setIsVisible(1);
                        //filter.setPlaceHolderText(filterData.name);
                        filter.setIcon("i-tag-a");
                        filter.setTagContainerId('selected-' + filterData.name);
                        filter.setTagContainerCaption('Selected ' + filterData.name + ':');
                        filter.setMinInputSuggestionLength(2);
                        filter.setLabel(filterData.name);
                        filter.setShowCount(true);
                        filter.setShowClear(true);

                        if(filterData.hasSearchFilter){

                            filter.setContainSearchEnabled(true);
                        }

                        dynamicFilters.push({
                            filter: filter,
                            filterId: filterId,
                            name: filterData.name,
                            type: filterData.type,
                            category: filterData.category,
                            categoryName: filterData.categoryName
                        });
                    }
                    else if(filterData.type === 'searchField'){

                        filterId = filterData.id;
                        filter = new filterSimple_template(filterId, this.getTemplateViewModel(), this.caller);
                        filter.setLabel(filterData.name);

                        dynamicFilters.push({
                            filter: filter,
                            filterId: filterId,
                            name: filterData.name,
                            type: filterData.type,
                            category: filterData.category,
                            categoryName: filterData.categoryName
                        });
                    }
                })
            }
        }

        this.getTemplateViewModel().dynamicFilters(dynamicFilters);

        let dynamicFiltersGrouped = Object.values(dynamicFilters.reduce((acc, item) => {

            // Check if the category already exists
            if (!acc[item.categoryName]) {
                acc[item.categoryName] = {
                    categoryName: item.categoryName,
                    names: {}
                };
            }

            // Check if the name already exists within the category
            if (!acc[item.categoryName].names[item.name]) {
                acc[item.categoryName].names[item.name] = {
                    name: item.name,
                    filters: []
                };
            }

            // Push the filter into the correct name group
            acc[item.categoryName].names[item.name].filters.push({
                type: item.type,
                filter: item.filter,
                filterId: item.filterId
            });

            return acc;
        }, {}));

        this.getTemplateViewModel().dynamicFiltersGrouped(dynamicFiltersGrouped);

        let dynamicFiltersGroupedByName = Object.values(dynamicFilters.reduce((acc, item) => {

            if (!acc[item.name]) {
                acc[item.name] = { name: item.name, category: item.category, filters: [] };
            }
            acc[item.name].filters.push({ type: item.type, filter: item.filter, filterId: item.filterId });
            return acc;
        }, {}));

        this.getTemplateViewModel().dynamicFiltersGroupedByName(dynamicFiltersGroupedByName);
    }

    public setDynamicAutoCompleteMultiSelectFilterItems(filterId, items){

        let dynamicFilters = this.getTemplateViewModel().dynamicFilters();
        let filter = dynamicFilters.find(filters => filters.filter.idElement === filterId).filter;
        if (filter) {

            filter.setItems(items);
            this.getTemplateViewModel().dynamicFilters(dynamicFilters);
        }
        filter.setItems(items);
    }

    public setTimelineAnnotationsData(timelineAnnotationsData) {

        for(let i = 0; i < timelineAnnotationsData.length; i++) {

            timelineAnnotationsData[i].dateOrig = timelineAnnotationsData[i].date;
            timelineAnnotationsData[i].date = new Date(timelineAnnotationsData[i].date);
        }

        this.getTemplateViewModel().timelineAnnotationsData(timelineAnnotationsData);

        // format for tooltip
        let formattedAnnotationTooltip = '<ul>';
        for(let i = 0; i < timelineAnnotationsData.length; i++) {

            let formattedDate = timelineAnnotationsData[i].dateOrig.substring(0, 10)

            formattedAnnotationTooltip += '<li class="col"><strong>' + formattedDate + '</strong><p>'+ timelineAnnotationsData[i].annotation +'</p></li>';
        }
        formattedAnnotationTooltip += '</ul>';


        this.annotationTooltip.setContent(formattedAnnotationTooltip);
    }

    public clearTimelineAnnotatonData(){

        this.getTemplateViewModel().timelineAnnotationsData([]);
    }

    /**
     * @inheritDoc
     */
    public getViewModelForRequest(): Object{

        let selectedDynamicFilters = [];
        let dynamicFilters = this.getTemplateViewModel().dynamicFilters();
        if(typeof dynamicFilters !== "undefined" && dynamicFilters !== null && Object.keys(dynamicFilters).length !== 0) {

            for(let dynamicFilter of dynamicFilters) {

                if(dynamicFilter.type === 'multiSelect') {

                    let items = dynamicFilter.filter.getTemplateViewModel().items();
                    let searchKeyword = dynamicFilter.filter.getContainSearchFilterKeyword();
                    let selectedIds = dynamicFilter.filter.getTemplateViewModel().selectedItems();
                    let filteredItems = items.filter(item => selectedIds.includes(item.id));

                    if(filteredItems.length > 0 || searchKeyword != '') {

                        selectedDynamicFilters.push({

                            [dynamicFilter.category]: {

                                [dynamicFilter.name]: {

                                    id: dynamicFilter.filterId,
                                    type: dynamicFilter.type,
                                    items: filteredItems,
                                    keyword: searchKeyword
                                }
                            }
                        });
                    }
                }
                else if(dynamicFilter.type === 'autoCompleteMultiSelect') {

                    let selectedIds = dynamicFilter.filter.getTemplateViewModel().selectedItems();
                    let searchKeyword = dynamicFilter.filter.getContainSearchFilterKeyword();
                    let filteredItems = selectedIds;

                    if(filteredItems.length > 0 || searchKeyword != '') {

                        selectedDynamicFilters.push({

                            [dynamicFilter.category]: {

                                [dynamicFilter.name]: {

                                    id: dynamicFilter.filterId,
                                    type: dynamicFilter.type,
                                    items: filteredItems,
                                    keyword: searchKeyword
                                }
                            }
                        });
                    }
                }
                else if(dynamicFilter.type === 'searchField') {

                    let searchKeyword = dynamicFilter.filter.getTemplateViewModel().filterKeyword();

                    if(searchKeyword) {

                        selectedDynamicFilters.push({

                            [dynamicFilter.category]: {
                                [dynamicFilter.name]: {
                                    id: dynamicFilter.filterId,
                                    type: dynamicFilter.type,
                                    keyword: searchKeyword
                                }
                            }
                        });
                    }
                }
            }
        }

        return {
            filters : {
                selectedDynamicFilters: selectedDynamicFilters,
                selectedBrand: this.brandFilter.getTemplateViewModel().selectedOption(),
                selectedBrandText: this.brandFilter.getTemplateViewModel().selectedOptionText(),
                dateFilterType: this.getTemplateViewModel().dateRangeFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateRangeFilter.startDate(),
                endDate: this.getTemplateViewModel().dateRangeFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateRangeFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateRangeFilter.toRange(),
                keywords: this.getTemplateViewModel().searchField.filterKeyword()


            },
            pagination: this.getTemplateViewModel().pagination
        };
    }

    public getSelectedBrand(){

        return this.brandFilter.getTemplateViewModel().selectedOption();
    }

    /**
     * Build the date Picker calendar.
     */
    public buildDatePickerCalendar(){

        this.dateRangeFilter.buildCalendar();
    }

    public setIndicatorsData(indicatorsData) {

        this.getTemplateViewModel().graphAxes(indicatorsData.graphAxes);
        this.getTemplateViewModel().graphLines(indicatorsData.graphLines);

        for(let i = 0; i < indicatorsData.dateRange.data.length; i++) {

            indicatorsData.dateRange.data[i].date = new Date(indicatorsData.dateRange.data[i].date);
        }

        this.getTemplateViewModel().indicatorsDateRange(indicatorsData.dateRange);
        this.getTemplateViewModel().indicatorsDateRangeEmpty(indicatorsData.dateRange.data.length > 0 ? false : true);
    }

    public setBrandFilterItems(portfolios): void{

        let groups = [];

        this.brandFilter.setIncludeAllOptions(true);

        for(let portfolio of portfolios){

            let subGroups = [];

            let portfolioItem = {"id": portfolio.id, "name": portfolio.name, "cssClasses": portfolio.logo, "type": 'portfolio'};

            if (!(typeof(portfolio.disabled) !== 'undefined' && portfolio.disabled === true)){

                groups.push(portfolioItem);

                for(let brand of portfolio.brands){

                    let brandItem = {"id": brand.id, "name": brand.name, "cssClasses": brand.logo, "iconUrl": brand.logoUrl, "type": 'brand'};

                    subGroups.push(brandItem);
                }
                portfolioItem['subGroups'] = subGroups;
            }else{

                for(let brand of portfolio.brands){

                    let brandItem = {"id": brand.id, "name": brand.name, "cssClasses": brand.logo, "iconUrl": brand.logoUrl, "type": 'brand'};
                    groups.push(brandItem);

                }
            }

        }

        // call setGroups function

        this.brandFilter.setGroups(groups);
        //this.brandFilter.setSelectedOption('all');
    }

    public setBrandShortName(brandShortName) {

        this.getTemplateViewModel().brandShortName(brandShortName);
    }

    public setCusotmDimensionNames(customDimensions: Array<any>){

        this.getTemplateViewModel().customDimensions(customDimensions);
    }

    public setPermalinksData(permalinksData){

        this.getTemplateViewModel().permalinksData(permalinksData);
    }

    public setPermalinksTotalRow(permalinksTotalRow){

        this.getTemplateViewModel().permalinksTotalRow(permalinksTotalRow);
    }

    public setCsvExportData(exportData){

        this.getTemplateViewModel().permalinksExportData(exportData);
    }

    public setDatesSelected(){

        this.getTemplateViewModel().dateStartSelected(this.getTemplateViewModel().dateRangeFilter.startDate());
        this.getTemplateViewModel().dateEndSelected(this.getTemplateViewModel().dateRangeFilter.endDate());
    }

    public exportCsvData(){

        let fileName;

        let exportDataView = [];
        for (let exportDataRow of this.getTemplateViewModel().permalinksExportData()) {

            let exportDataViewRow = this.getFormatedExportRow(exportDataRow);
            exportDataView.push(exportDataViewRow);
        }

        fileName = "permalinks_search_keyword_" + this.getTemplateViewModel().searchField.filterKeyword().replace(/[^\w\s]/gi, "_") + "_" + this.dateRangeFilter.getTemplateViewModel().startDate() + "_" + this.dateRangeFilter.getTemplateViewModel().endDate()+ ".csv";
        this.exportDataCsv.exportToCsv(fileName, exportDataView);
    }

    private getFormatedExportRow(exportDataRow) {

        let exportDataViewRow = [];

        exportDataViewRow["Property"] = exportDataRow.brand;
        exportDataViewRow["Page Path"] = exportDataRow.permalink;
        exportDataViewRow["Full Page Path"] = exportDataRow.permalinkUrl;
        exportDataViewRow["Clicks"] = Number(exportDataRow.clickCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["CTR"] = Number(exportDataRow.ctr).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})  + '%';
        exportDataViewRow["Impressions"] = Number(exportDataRow.impressionCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});

        return exportDataViewRow;
    }

    public setResultInfo(nbResults, nbPages, execTime) {

        this.resultsInfo.setExecutionTime(execTime);
        this.resultsInfo.setNbResults(nbResults);
        this.resultsInfo.setNbPages(nbPages);
    }

    public updatePagination(totalCount){

        this.pagination.setNumberItemToPaginate(totalCount);
    }

    private getCsvData(){

        this.caller.getListDataForCSV();
    }

    public onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);
        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public stopPropagation(event){

        event.stopPropagation();
    }

    public updateIndicatorsGraphData(){

        this.indicatorsChart.setCssHeight("230px");

        let axes = this.getTemplateViewModel().graphAxes();
        let graphLines = this.getTemplateViewModel().graphLines();
        let chartData = this.getTemplateViewModel().indicatorsDateRange().data;

        this.indicatorsChart.setNbOfXAxes(axes.length)
        this.indicatorsChart.setDateFields(axes);
        this.indicatorsChart.setCursorEnabled(1);
        this.indicatorsChart.setLabelMaxWidth(80);
        this.indicatorsChart.setAutoRotateLabels(1);
        this.indicatorsChart.setClickableLegend(1);
        this.indicatorsChart.setXScrollbarEnabled(0);
        this.indicatorsChart.setDateFormat("daily");

        let chart = this.indicatorsChart.setupChart(chartData);

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        this.indicatorsChart.applyValueAxisFormatting(valueAxis);
        valueAxis.renderer.minWidth = 50;
        valueAxis.renderer.grid.template.disabled = true;

        valueAxis.title.fontWeight = "bold";
        valueAxis.min = 0;

        let count = 0;
        for (let graphLine of graphLines) {

            let series = chart.series.push(new am4charts.LineSeries());

            let color = googleInsights_template.getPaletteColor(count);
            series.dataFields.valueY =  graphLine.value;
            series.dataFields.customValue = graphLine.value;
            series.dataFields.dateX = graphLine.field;
            series.strokeOpacity = 1;
            series.strokeWidth = 2;
            series.fill = am4core.color(color);
            series.stroke = am4core.color(color);
            series.yAxis = valueAxis;
            series.name = graphLine.name;

            series.tooltipText = "{name}: [bold]{customValue}[/]";

            series.smoothing = "monotoneX";
            series.showOnInit = true;

            let interfaceColors = new am4core.InterfaceColorSet();

            let bullet = series.bullets.push(new am4charts.CircleBullet());
            bullet.circle.radius = 4;
            bullet.circle.opacity = 1;
            bullet.circle.strokeWidth = 1;
            bullet.circle.stroke = interfaceColors.getFor("background");
            bullet.circle.opacity = 1;
            bullet.circle.strokeOpacity = 0.9;

            series.minBulletDistance = 2.5;

            count++;
        }

        chart.events.once("ready", () => {

            for (let annotation of this.getTemplateViewModel().timelineAnnotationsData()) {

                // Use the axis of a known series to choose the correct x-axis (you have multiple).
                const series0 = chart.series.getIndex(0) as am4charts.LineSeries;
                if (!series0 || !series0.xAxis) return;

                // Cast the axis to DateAxis so TS knows about min/max, strictMinMax, etc.
                const xAxis = series0.xAxis as am4charts.DateAxis;

                // The moment you want to mark:
                let eventDateTmp = annotation.date;


                let lineOffset = 43200000;
                eventDateTmp.setHours(0, 0, 0, 0);


                let offset = (eventDateTmp.getTimezoneOffset() * 60 * 1000);


                let eventDate = new Date(eventDateTmp.getTime() - offset + lineOffset);


                const ts = +eventDate;

                // Create the range and cast it to DateAxisDataItem so .value/.date are valid
                const range = xAxis.axisRanges.create() as am4charts.DateAxisDataItem;

                // Either set value (timestamp) or date (Date) — both are valid on DateAxisDataItem
                range.value = ts;              // or: range.date = eventDate;

                // Style the line
                range.grid.stroke = am4core.color("#FF0000");
                range.grid.strokeWidth = 2;
                range.grid.strokeOpacity = 1;
                range.grid.strokeDasharray = "4,4";
                range.grid.zIndex = 1000;

                // Label / note
                //range.label.text = "Annotation";
                range.label.rotation = -90;
                range.label.horizontalCenter = "right";
                range.label.verticalCenter = "bottom";
                range.label.dy = -150;                     // tweak up/down if needed

                range.label.inside = true;
                range.label.fill = am4core.color("#D41C5C");
                range.label.padding(0, 6, 0, 6);
            }
        });

        if(chart.logo){

            chart.logo.disabled = true;
        }
    }

    static getPaletteColor(number) {

        switch(number) {
            case 0:
                return "#312D69";
            case 1:
                return "#D8366D";
            case 2:
                return "#537749";
            case 3:
                return "#1E8EFF";
            case 4:
                return "#FED500";
            case 5:
                return "#E28413";
            default:
                return "#000000";  // Default case if number doesn't match any case
        }
    }

    static stringToColour(str){

        let hash = 0;
        for (let i = 0; i < str.length; i++){

            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        let colour = '#';
        for (let i = 0; i < 3; i++){

            let value = (hash >> (i * 8)) & 0xFF;
            colour += ('00' + value.toString(16)).substr(-2);
        }

        return colour;
    }

    public setViewModelFromRequest(params : Array<any>): void{

        if(typeof params['selectedBrand'] !== 'undefined'){

            this.brandFilter.getTemplateViewModel().selectedOption(params['selectedBrand']);
        }

        if(typeof params['selectedBrandText'] !== 'undefined'){

            this.brandFilter.getTemplateViewModel().selectedOptionText(params['selectedBrandText']);
        }
        if(typeof params['keywords'] !== 'undefined'){

            this.searchField.getTemplateViewModel().filterKeyword(params['keywords']);
        }

        this.presetFilter.setDates(this.dateRangeFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);

        if(typeof params['selectedDynamicFilters'] !== 'undefined' && Array.isArray(params['selectedDynamicFilters'])){

            let dynamicFilters = this.getTemplateViewModel().dynamicFilters();

            params['selectedDynamicFilters'].forEach(selectedDynamicFilter => {

                Object.values(selectedDynamicFilter).forEach(category => {

                    if (typeof category === 'object' && category !== null) {

                        Object.values(category).forEach(categoryFilter => {

                            let dynamicFilter = dynamicFilters.find(obj => obj.filter.idElement === categoryFilter.id);

                            if (dynamicFilter) {

                                let filter = dynamicFilter.filter;

                                if(categoryFilter.type === 'multiSelect'){

                                    if(categoryFilter.items.length > 0 || categoryFilter.keyword != ''){

                                        let filterIds = categoryFilter.items.map(obj => obj.id);
                                        this.presetFilter.setMultiSelectorPresetFilters(filter, filterIds, categoryFilter.keyword);
                                    }
                                }
                                else if(categoryFilter.type === 'autoCompleteMultiSelect'){

                                    if(categoryFilter.items.length > 0 || categoryFilter.keyword != ''){

                                        let filterIds = categoryFilter.items.map(obj => obj.id);
                                        let filterNames = categoryFilter.items.map(obj => obj.name);
                                        this.presetFilter.setMultipleAutocompletePresetFilter(filter, filterIds, filterNames, categoryFilter.keyword);
                                    }
                                }
                                else if(categoryFilter.type === 'searchField'){

                                    if(categoryFilter.keyword != ''){

                                        filter.getTemplateViewModel().filterKeyword(categoryFilter.keyword);
                                    }

                                }
                            }
                        });
                    }
                });

            });

            this.getTemplateViewModel().dynamicFilters(dynamicFilters);
        }
    }

    private formatMinuteSeconds(value){

        if (isNaN(parseInt(value))) {

            return value;
        }else {

            return Math.floor(parseInt(value) / 60) + ":" + (parseInt(value) % 60).toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
            });
        }
    }

    public setCustomDimensionLargeSetFilterItems(customDimension, customDimensionValues: Array<any>){

        let customDimensionLargeSetFilters = this.getTemplateViewModel().customDimensionLargeSetFilters();
        let filter = customDimensionLargeSetFilters.find(filters => filters.idElement === 'customDimensionLargeSetFilter-' + customDimension);
        if (filter) {

            filter.setItems(customDimensionValues);
            this.getTemplateViewModel().customDimensionLargeSetFilters(customDimensionLargeSetFilters);
        }
    }

    private isDateDifferenceWithinDays(startDate, endDate, numDays) {

        const dateA = new Date(startDate);
        const dateB = new Date(endDate);

        const diffInMs = Math.abs(dateA.getTime() - dateB.getTime());
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

        return (diffInDays + 1) <= numDays;
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/googleInsights_template.ts